// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3g08R","name":"Header_name__1lqGT","birthday":"Header_birthday__1YbKk","skeleton":"Header_skeleton__3tWXh"};